<template>
  <div id="rose-chart">
    <div class="rose-chart-title">用户类型分布</div>
    <dv-charts :option="option" />
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'RoseChart',
  computed: {...mapGetters(['companyTypeList'])},
  data () {
    return {
      option: {}
    }
  },
  methods: {
    async createData () {
      const { randomExtend } = this
      await this.$store.dispatch('screen/screenSet',{}).then(Response=>{
        this.option = {
          series: [
            {
              type: 'pie',
              radius: '50%',
              roseSort: false,
              data:this.companyTypeList,
              insideLabel: {
                show: false
              },
              outsideLabel: {
                formatter: '{name} {value}%',
                labelLineEndLength: 20,
                style: {
                  fill: '#fff'
                },
                labelLineStyle: {
                  stroke: '#fff'
                }
              },
              roseType: true
            }
          ],
          color: ['#da2f00', '#fa3600', '#ff4411', '#ff724c', '#541200', '#801b00', '#a02200', '#5d1400', '#b72700']
        }
      });
    },
    randomExtend (minNum, maxNum) {
      if (arguments.length === 1) {
        return parseInt(Math.random() * minNum + 1, 10)
      } else {
        return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10)
      }
    }
  },
  mounted () {
    const { createData } = this

    createData()

    // setInterval(createData, 30000)
  }
}
</script>

<style lang="less">
#rose-chart {
  width: 30%;
  height: 100%;
  background-color: rgba(6, 30, 93, 0.5);
  border-top: 2px solid rgba(1, 153, 209, .5);
  box-sizing: border-box;

  .rose-chart-title {
    height: 50px;
    font-weight: bold;
    text-indent: 20px;
    font-size: 20px;
    display: flex;
    align-items: center;
  }

  .dv-charts-container {
    height: calc(~"100% - 50px");
  }
}
</style>
